import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render terms and conditions section for FAQ Page
 */
const TermsAndConditionsSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans leading-[1.4]"
      data-testid="terms-and-conditions-section-component"
    >
      <AccordionV2
        testId="terms-and-conditions"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="2. What are the terms and conditions of the prizes?"
            className="px-4"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mx-4 px-6 py-4 pb-0">
          <p className="mt-2">
            <strong>OCBC</strong>
          </p>

          <p className="mb-0">
            <strong>Terms and conditions of the loan prize:</strong>
          </p>

          <ul className="mb-18 list-outside list-[lower-alpha] pl-4">
            <li>
              The term loan is an unsecured facility, with the quantum of the
              loan as set out in the table below:
              <table className="my-4 w-1/2 border border-gray-850 text-gray-550">
                <tr className="border border-gray-850">
                  <td className="border-r border-gray-850 pl-8">
                    Country of incorporation / formation of the winner or the
                    winner’s subsidiary, partnership or sole proprietorship that
                    is receiving the loan, where applicable
                  </td>
                  <td className="px-8 align-top">
                    “Emerging Enterprise Award” and the “Emerging Enterprise
                    Sustainability Award”
                  </td>
                </tr>

                <tr className="border border-gray-850">
                  <td className="border-r border-gray-850 pl-8">Singapore</td>
                  <td className="px-8">SGD 200,000</td>
                </tr>

                <tr className="border border-gray-850">
                  <td className="border-r border-gray-850 pl-8">Malaysia</td>
                  <td className="px-8">MYR 600,000</td>
                </tr>

                <tr className="border border-gray-850">
                  <td className="border-r border-gray-850 pl-8">Hong Kong</td>
                  <td className="px-8">HKD 1,000,000</td>
                </tr>

                <tr className="border border-gray-850">
                  <td className="border-r border-gray-850 pl-8">Indonesia</td>
                  <td className="px-8">IDR 2,000,000,000</td>
                </tr>
              </table>
            </li>

            <li>
              The loan shall be interest-free for 24 months from the date of
              loan disbursement.
            </li>

            <li>
              No interest, processing and annual fees will be charged for 24
              months from the date of loan disbursement.
            </li>

            <li>
              Disbursement of the term loan shall only be made into a business
              account with OCBC Bank or the relevant OCBC Subsidiary which is
              providing the term loan, as the case may be;
            </li>

            <li>
              If the winner of the relevant Award is not incorporated or formed
              in Singapore, Malaysia, Indonesia and/or Hong Kong, they must
              incorporate a subsidiary (if the winner is a company or an LLP),
              establish a partnership (if the winner is a partnership) or
              establish a sole proprietorship (if the winner is a sole
              proprietorship) in any of these countries to receive the term
              loan;
            </li>

            <li>
              Full terms and conditions is reflected in the application form.
            </li>
          </ul>

          <p>
            <strong>RSM</strong>
          </p>

          <p className="mb-0">
            <strong>
              Terms and conditions of the RSM Consulting Package for Growing
              Businesses prize:
            </strong>
          </p>

          <ul className="mb-6 list-outside list-[lower-alpha] pl-4">
            <li>
              The Consulting Package will only be provided to companies that
              receive the Emerging Enterprise Award and Emerging Enterprise
              Sustainability Award, excluding any related companies or group of
              companies.
            </li>

            <li>
              Redemption of the prize shall not be applicable for assurance, tax
              advisory and valuation advisory services.
            </li>

            <li>
              The prize is non-transferrable, not exchangeable for cash, and
              must be utilised within six months of the award.
            </li>

            <li>
              Acceptance of any engagement by RSM, pursuant to the Consulting
              Package, is subject to the winner companies complying with RSM’s
              internal requirements on client acceptance procedures.
            </li>
          </ul>

          <p>
            These terms and conditions shall be governed by the laws of
            Singapore. The courts of Singapore shall have exclusive jurisdiction
            to settle any dispute, controversy or claim arising from or in
            connection with these terms and conditions and/or the Emerging
            Enterprise Award and Emerging Enterprise Sustainability Award
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default TermsAndConditionsSection;
